import gql from "graphql-tag";

export const FIND_TIPOS_ENCUESTA = gql`
  query findTiposEncuesta {
    findTiposEncuesta {
      id
      tipo
      descripcion
    }
  }
`;

export const FIND_TIPO_ENCUESTA_BY_ID = gql`
  query findTipoEncuestaById($id_tipo_encuesta: Int!) {
    findTipoEncuestaById(id: $id_tipo_encuesta) {
      id
      tipo
      preguntas {
        header
        preguntas {
          id
          pregunta
          tipo {
            name
          }
          labels
          from
          to
          bottom
          top
        }
      }
      help {
        html
      }
    }
  }
`;

export const FIND_ENCUESTAS_COMPLETADAS_BY_MEDICO = gql`
  query findEncuestasCompletadasByMedico($id_medico: Int!) {
    findEncuestasCompletadasByMedico(id_medico: $id_medico) {
      id
      respuestas
      resultado
      resultado_numerico
      color
      fill_at
      estado_encuesta {
        nombre
      }
      tipo_encuesta {
        id
        tipo
        descripcion
      }
      paciente {
        dni
        nombre
        primer_apellido
      }
    }
  }
`;

export const FIND_ENCUESTA_BY_ID = gql`
  query findEncuestaBy($id: Int) {
    findEncuestaBy(id: $id) {
      id
      respuestas
      resultado
      resultado_numerico
      observaciones
      color
      tipo_encuesta {
        id
        tipo
        preguntas {
          header
          preguntas {
            id
            pregunta
            tipo {
              name
            }
            labels
            from
            to
            bottom
            top
          }
        }
        help {
          html
        }
      }
    }
  }
`;
